import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
`;

export const Container = styled.div`
  background: #fff;
  width: 700px;
  max-width: 95vw;
  max-height: 90vh;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: 'Inter', sans-serif;
`;

export const Header = styled.div`
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #F0F0F0;

  h2 {
    font-size: 20px;
    font-weight: 700;
    color: #303030;
    margin: 0;
    span {
      font-weight: 400;
      color: #8D8D8D;
      font-size: 16px;
      margin-left: 8px;
    }
  }
`;

// Botão X com hover cinza
export const CloseBtn = styled.button`
  background: transparent;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  cursor: pointer;
  color: #8D8D8D;
  transition: all 0.2s ease;
  padding: 0;

  &:hover {
    background: #F4F4F4;
    color: #303030;
  }
`;

export const Content = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  &::-webkit-scrollbar { width: 6px; }
  &::-webkit-scrollbar-track { background: #f1f1f1; }
  &::-webkit-scrollbar-thumb { background: #ccc; border-radius: 3px; }
`;

export const Card = styled.div`
  border: 1px solid #EBEBEB;
  border-radius: 12px;
  padding: 20px;
  background: #fff;
  transition: all 0.2s ease;
  position: relative; 
  z-index: 1; 
  
  &:hover {
    border-color: #D0D0D0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    z-index: 2;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px; /* Garante espaço entre o texto e os botões */
`;

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
  color: #666;
  
  /* MÁGICA DO TRUNCATE: */
  flex: 1; /* Ocupa o espaço que sobrar */
  min-width: 0; /* Permite encolher se necessário */

  strong { color: #303030; font-weight: 700; }
  .blue-text { color: #0090D3; font-weight: 700; }
  
  .item-name { 
    font-weight: 700; 
    color: #303030; 
    font-size: 15px;
    
    /* Configurações para cortar com "..." */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
  }
`;
export const CardActions = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

// === ESTILOS DO DROPDOWN (Que estavam faltando e causaram o erro) ===
export const ActionWrapper = styled.div`
  position: relative;
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  border: 1px solid #EBEBEB;
  min-width: 180px;
  z-index: 100;
  overflow: hidden;
  padding: 8px 0;
  animation: fadeIn 0.2s ease-in-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-5px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const DropdownItem = styled.button<{
  $emphasize?: boolean
  $cursorBlocked?: boolean
}>`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: transparent;
  text-align: left;
  cursor: ${({ $cursorBlocked }) => ($cursorBlocked ? 'not-allowed' : 'pointer')};
  font-size: 14px;
  color: ${({ $emphasize }) => ($emphasize ? '#0090D3' : '#303030')};
  font-family: 'Inter', sans-serif;
  transition: background 0.2s;

  &:hover {
    background: ${({ $cursorBlocked }) =>
      $cursorBlocked ? 'transparent' : '#F5F5F5'};
  }

  svg {
    color: ${({ $emphasize }) => ($emphasize ? '#0090D3' : '#555')};
    width: 18px;
    height: 18px;
  }
`;
// =================================================================

export const OutlineButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 1px solid #0090D3;
  color: #0090D3;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover { background: #F0F9FF; }
`;

// Botão Redondo (Seta) alinhado com grid
export const IconButton = styled.button`
  background: transparent;
  border: 1px solid #8D8D8D;
  border-radius: 50%;
  width: 32px; height: 32px;
  display: grid; 
  place-items: center; 
  padding: 0;
  cursor: pointer;
  color: #666;
  transition: all 0.2s;
  
  &:hover { 
    border-color: #303030; 
    color: #303030; 
    background-color: #F9F9F9; 
  }
  
  svg { stroke-width: 1.5px; }
`;

// === ESTILOS DA TIMELINE ===
export const TimelineContainer = styled.div`
  margin-top: 24px;
  padding-left: 8px;
  position: relative;
`;

export const TimelineItem = styled.div<{ $isActive: boolean; $isLast: boolean }>`
  display: flex;
  gap: 16px;
  position: relative;
  padding-bottom: ${props => props.$isLast ? '0' : '20px'};

  /* Linha vertical */
  &::before {
    content: '';
    position: absolute;
    left: 5px; top: 14px; bottom: 0;
    width: 2px;
    background-color: ${props => props.$isActive ? '#0090D3' : '#E0E0E0'};
    display: ${props => props.$isLast ? 'none' : 'block'};
  }
`;

export const Dot = styled.div<{ $isActive: boolean }>`
  width: 12px; height: 12px;
  border-radius: 50%;
  background-color: ${props => props.$isActive ? '#0090D3' : '#E0E0E0'};
  flex-shrink: 0; margin-top: 5px; z-index: 1;
`;

export const StepContent = styled.div`
  display: flex; justify-content: space-between; width: 100%; font-size: 13px;
`;

export const StepName = styled.span<{ $isCurrent: boolean }>`
  color: ${props => props.$isCurrent ? '#0090D3' : '#666'};
  font-weight: ${props => props.$isCurrent ? '700' : '400'};
`;

export const StepDate = styled.span<{ $isCurrent: boolean }>`
  color: ${props => props.$isCurrent ? '#0090D3' : '#8D8D8D'};
  font-weight: ${props => props.$isCurrent ? '700' : '400'};
`;

export const Footer = styled.div`
  padding: 20px 24px;
  gap: 20px;
  border-top: 1px solid #F0F0F0;
  display: flex; justify-content: flex-end;
`;

export const FooterButton = styled.button`
  background: #fff;
  border: 1px solid #0090D3;
  color: #0090D3;
  padding: 10px 32px;
  border-radius: 24px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
  &:hover { background: #F0F9FF; }
`;

export const LinkButton = styled.div`
  display: flex;
  gap: 4px;
  background: #0090D3;
  border: 1px solid #0090D3;
  color: #FFF;
  padding: 10px 32px;
  border-radius: 24px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
`